export const cities = {
  austin: {
    slug: 'austin',
    city: 'Austin',
    state: 'TX',
    fullName: 'Austin Metro, TX',
    pageTitle: 'TV Mounting in Austin Metro, TX | Hero TV Mounting',
    metaDescription: 'Professional TV mounting in Austin Metro with same-day availability, wire concealment, and expert installation. Book online in minutes.',
    neighborhoods: ['Downtown', 'South Congress', 'Domain', 'Zilker', 'East Austin', 'Westlake', 'Cedar Park', 'Round Rock'],
    path: '/locations/austin',
  },
  'san-antonio': {
    slug: 'san-antonio',
    city: 'San Antonio',
    state: 'TX',
    fullName: 'San Antonio, TX',
    pageTitle: 'TV Mounting in San Antonio, TX | Hero TV Mounting',
    metaDescription: 'Expert TV mounting services in San Antonio. Same-day installation, cable management, and professional mounting. Book your service today.',
    neighborhoods: ['Downtown', 'Alamo Heights', 'Stone Oak', 'The Dominion', 'Southtown', 'Medical Center', 'Northeast Side', 'West Side'],
    path: '/locations/san-antonio',
  },
  'fort-worth': {
    slug: 'fort-worth',
    city: 'Fort Worth',
    state: 'TX',
    fullName: 'Fort Worth, TX',
    pageTitle: 'TV Mounting in Fort Worth, TX | Hero TV Mounting',
    metaDescription: 'Reliable TV mounting services in Fort Worth. Professional installation, wire concealment, and same-day availability. Get a quote now.',
    neighborhoods: ['Downtown', 'Cultural District', 'Southside', 'Near Southside', 'Trinity Park', 'Westside', 'North Fort Worth', 'Alliance'],
    path: '/locations/fort-worth',
  },
  dallas: {
    slug: 'dallas',
    city: 'Dallas',
    state: 'TX',
    fullName: 'Dallas Metro, TX',
    pageTitle: 'TV Mounting in Dallas Metro, TX | Hero TV Mounting',
    metaDescription: 'Professional TV mounting in Dallas Metro with expert technicians. Same-day service, cable concealment, and secure installation. Book today.',
    neighborhoods: ['Downtown', 'Uptown', 'Deep Ellum', 'Bishop Arts', 'Preston Center', 'Lakewood', 'Oak Cliff', 'Addison'],
    path: '/locations/dallas',
  },
  houston: {
    slug: 'houston',
    city: 'Houston',
    state: 'TX',
    fullName: 'Houston Metro, TX',
    pageTitle: 'TV Mounting in Houston Metro, TX | Hero TV Mounting',
    metaDescription: 'Top-rated TV mounting services in Houston Metro. Professional installation, wire management, and same-day availability. Schedule your service.',
    neighborhoods: ['Downtown', 'Montrose', 'River Oaks', 'The Heights', 'Galleria', 'Medical Center', 'Sugar Land', 'Katy'],
    path: '/locations/houston',
  },
  tampa: {
    slug: 'tampa',
    city: 'Tampa',
    state: 'FL',
    fullName: 'Tampa, FL',
    pageTitle: 'TV Mounting in Tampa, FL | Hero TV Mounting',
    metaDescription: 'Professional TV mounting in Tampa with same-day availability, wire concealment, and expert installation. Book online in minutes.',
    neighborhoods: ['Downtown', 'Ybor City', 'Hyde Park', 'SoHo', 'Channelside', 'Westshore', 'Carrollwood', 'Brandon'],
    path: '/locations/tampa',
  },
  'st-petersburg': {
    slug: 'st-petersburg',
    city: 'St. Petersburg',
    state: 'FL',
    fullName: 'St. Petersburg, FL',
    pageTitle: 'TV Mounting in St. Petersburg, FL | Hero TV Mounting',
    metaDescription: 'Expert TV mounting services in St. Petersburg. Same-day installation, cable management, and professional mounting. Book your service today.',
    neighborhoods: ['Downtown', 'Old Northeast', 'Grand Central', 'Historic Kenwood', 'Snell Isle', 'Sunset Beach', 'Gulfport', 'Tyrone'],
    path: '/locations/st-petersburg',
  },
  orlando: {
    slug: 'orlando',
    city: 'Orlando',
    state: 'FL',
    fullName: 'Orlando, FL',
    pageTitle: 'TV Mounting in Orlando, FL | Hero TV Mounting',
    metaDescription: 'Reliable TV mounting services in Orlando. Professional installation, wire concealment, and same-day availability. Get a quote now.',
    neighborhoods: ['Downtown', 'Winter Park', 'College Park', 'Mills 50', 'Lake Nona', 'Dr. Phillips', 'Altamonte Springs', 'Kissimmee'],
    path: '/locations/orlando',
  },
  'fort-lauderdale': {
    slug: 'fort-lauderdale',
    city: 'Fort Lauderdale',
    state: 'FL',
    fullName: 'Ft. Lauderdale, FL',
    pageTitle: 'TV Mounting in Ft. Lauderdale, FL | Hero TV Mounting',
    metaDescription: 'Professional TV mounting in Ft. Lauderdale with expert technicians. Same-day service, cable concealment, and secure installation. Book today.',
    neighborhoods: ['Downtown', 'Las Olas', 'Victoria Park', 'Rio Vista', 'Coral Ridge', 'Wilton Manors', 'Pompano Beach', 'Hollywood'],
    path: '/locations/fort-lauderdale',
  },
  miami: {
    slug: 'miami',
    city: 'Miami',
    state: 'FL',
    fullName: 'Miami Metro, FL',
    pageTitle: 'TV Mounting in Miami Metro, FL | Hero TV Mounting',
    metaDescription: 'Top-rated TV mounting services in Miami Metro. Professional installation, wire management, and same-day availability. Schedule your service.',
    neighborhoods: ['Downtown', 'Brickell', 'Wynwood', 'Coral Gables', 'South Beach', 'Doral', 'Kendall', 'Aventura'],
    path: '/locations/miami',
  },
  atlanta: {
    slug: 'atlanta',
    city: 'Atlanta',
    state: 'GA',
    fullName: 'Atlanta Metro, GA',
    pageTitle: 'TV Mounting in Atlanta Metro, GA | Hero TV Mounting',
    metaDescription: 'Professional TV mounting in Atlanta Metro with same-day availability, wire concealment, and expert installation. Book online in minutes.',
    neighborhoods: ['Downtown', 'Midtown', 'Buckhead', 'Inman Park', 'Virginia-Highland', 'Old Fourth Ward', 'Decatur', 'Sandy Springs'],
    path: '/locations/atlanta',
  },
} as const;

export type CitySlug = keyof typeof cities;

export const getCityBySlug = (slug: string) => {
  return cities[slug as CitySlug] || null;
};

export const getAllCities = () => {
  return Object.values(cities);
};
